import React, { useState } from 'react';
import questions from './questions';
import Result from './Result';
import { Firstchar, Secondchar, Thirdchar, Fourthchar, Fifthchar } from './Result';

function Survey() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [FirstCharScore, setFirstCharScore] = useState(0);
  const [ThirdCharScore, setThirdCharScore] = useState(0);
  const [SecondCharScore, setSecondCharScore] = useState(0);
  const [FourthCharScore, setFourthCharScore] = useState(0);
  const [FifthCharScore, setFifthCharScore] = useState(0);
  const [isFinished, setIsFinished] = useState(false);
  


    const handleAnswer = (character, weight = 1) => {
      if (character === Firstchar) {
        setFirstCharScore(FirstCharScore + weight);
      } else if (character === Secondchar) {
        setSecondCharScore(SecondCharScore + weight);
      } else if (character === Thirdchar) {
        setThirdCharScore(ThirdCharScore + weight);
      } else if (character === Fourthchar) {
        setFourthCharScore(FourthCharScore + weight);
      }else if (character === 'Görkem') {
        setFifthCharScore(FifthCharScore + weight);
      }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
    } else {
      setIsFinished(true);
    }
  };

  if (isFinished) {
    return (
      <div>
        <Result FirstCharScore={FirstCharScore} SecondCharScore={SecondCharScore} ThirdCharScore={ThirdCharScore} FourthCharScore={FourthCharScore}  FifthCharScore={FifthCharScore}/>
      </div>
    );
  } else {
    const question = questions[currentQuestion];
    return (
      <div className="survey">
        {/* Use Base64 encoded image or ensure correct path */}
        <img
          src={`${process.env.PUBLIC_URL}/logo_full.png`}
          alt="Logo"
          className="logo-fixed-bottom"
        />
        <hr />
        <h2>
          Soru {currentQuestion } / {questions.length-1}
        </h2>
        <h3>{question.text}</h3>
        <div className="options">
          {question.options.map((option) => (
            <button
              key={option.text}
              onClick={() => handleAnswer(option.character, option.weight)}
            >
              {option.text}
            </button>
          ))}
        </div>
      </div>
    );
  }
}

export default Survey;
